import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { slidingHref } from "../router/router";
import SwipeNavigationInfo from "./swipe-navigation-info";


export default /*#__PURE__*/_defineComponent({
  __name: 'sliding-router-view',
  props: {
    name: { default: "sliding1" }
  },
  setup(__props: any) {

const props = __props;

const route = useRoute();

const noTransition = ref(false);

const href = ref("");
const visible = computed(() => {
  return !!href.value;
});

function back(): void {
  window.history.back();
}

function lockBodyScroll(): void {
  if (props.name === "sliding1") {
    document.documentElement.classList.add("body-scroll-locked");
  }
}

function unlockBodyScroll(): void {
  if (props.name === "sliding1") {
    document.documentElement.classList.remove("body-scroll-locked");
  }
}

watch(
  () => route.query,
  (newVal) => {
    noTransition.value = SwipeNavigationInfo.wasSwipeNavigation();
    if (route && route.matched && route.matched[0] && route.matched[0].components) {
      href.value = slidingHref(route, props.name);
    } else {
      href.value = "";
    }

    if (visible.value) {
      lockBodyScroll();
    } else {
      unlockBodyScroll();
    }
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sliding-router-view", {
      'sliding-router-view-hidden': !visible.value,
      'sliding-router-view-no-transition': noTransition.value,
    }])
  }, [
    _createVNode(_component_router_view, { name: _ctx.name }, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_KeepAlive, null, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ], 1024))
      ]),
      _: 1
    }, 8, ["name"]),
    _createElementVNode("div", { class: "sliding-router-navbar" }, [
      _createElementVNode("button", {
        onClick: back,
        class: "btn btn-lg btn-primary-back",
        type: "button"
      }, "Back")
    ])
  ], 2))
}
}

})